import { applyPromptQueueStateFromServer } from '../../prompt-turn-queue/runner.js';
import { enqueueLatestPromptQueueStateWork } from '../../prompt-turn-queue/runner/serial-prompt-queue-work.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handlePromptQueueStateMessage: BridgeMessageHandler<'prompt_queue_state'> = (msg, deps) => {
  enqueueLatestPromptQueueStateWork(async () => {
    try {
      await applyPromptQueueStateFromServer(msg, deps);
    } catch (err) {
      deps.log(`[Queue] applyPromptQueueStateFromServer failed: ${err instanceof Error ? err.message : String(err)}`);
    }
  });
};
